var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1203 -127)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.001 65)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    transform: "translate(1113.999 62)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "none",
    width: 30,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1212.167 136)",
    fill: "#363a4a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.888,
    height: 2.888,
    transform: "translate(4.332 4.332)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.888,
    height: 2.888
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.888,
    height: 2.888,
    transform: "translate(4.332 8.664)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.888,
    height: 2.888,
    transform: "translate(0 4.332)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.888,
    height: 2.888,
    transform: "translate(0 8.664)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.888,
    height: 2.888,
    transform: "translate(8.664)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.888,
    height: 2.888,
    transform: "translate(4.332)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.888,
    height: 2.888,
    transform: "translate(8.664 4.332)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.888,
    height: 2.888,
    transform: "translate(8.664 8.664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/gridView.ce684e4c.svg";
export { ForwardRef as ReactComponent };